import { Link } from 'react-router-dom'

export function RhDashboard() {
  return (
    <div>
      <h1 style={{ fontSize: 'var(--font-size-2xl)', fontWeight: 700, marginBottom: 'var(--space-8)' }}>
        Painel RH
      </h1>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: 'var(--space-4)',
        }}
      >
        <QuickCard
          icon="📋"
          title="Espelho de Ponto"
          description="Visualize e feche espelhos de funcionários."
          to="/rh/espelho"
        />
        <QuickCard
          icon="✏️"
          title="Tratamento"
          description="Abonos, ajustes e justificativas com trilha de auditoria."
          to="/rh/tratamento"
        />
      </div>
    </div>
  )
}

function QuickCard({ icon, title, description, to }: { icon: string; title: string; description: string; to: string }) {
  return (
    <Link to={to} style={{ textDecoration: 'none' }}>
      <div
        className="card"
        style={{ cursor: 'pointer' }}
        onMouseEnter={(e) => ((e.currentTarget as HTMLDivElement).style.boxShadow = 'var(--shadow-md)')}
        onMouseLeave={(e) => ((e.currentTarget as HTMLDivElement).style.boxShadow = 'var(--shadow-sm)')}
      >
        <div style={{ fontSize: '2rem', marginBottom: 'var(--space-3)' }}>{icon}</div>
        <h2 style={{ fontSize: 'var(--font-size-lg)', fontWeight: 600, marginBottom: 'var(--space-2)' }}>{title}</h2>
        <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-gray-600)' }}>{description}</p>
      </div>
    </Link>
  )
}
